import type { Route } from "./+types/category";
import { Link } from "react-router";
import { content } from "../lib/content";
import { categoryAccent } from "../utils/categoryAccent";
import { formatUtcShortDate } from "../utils/formatDate";

export async function loader({ params }: Route.LoaderArgs) {
  const list = await content.articles({ category: params.page, limit: 100 });
  if (list.total === 0) {
    throw new Response("Not Found", { status: 404 });
  }
  return { category: params.page, list };
}

export function meta({ data }: Route.MetaArgs) {
  if (!data) return [{ title: "Not found | Gazar" }];
  const title = data.category.replace(/-/g, " ").replace(/\b\w/g, (c) => c.toUpperCase());
  return [
    { title: `${title} | Gazar` },
    { name: "description", content: `Articles on ${title} by Gazar.` },
    { tagName: "link", rel: "canonical", href: `https://gazar.dev/${data.category}` },
  ];
}

export default function Category({ loaderData }: Route.ComponentProps) {
  const { category, list } = loaderData;
  const title = category.replace(/-/g, " ").replace(/\b\w/g, (c) => c.toUpperCase());
  return (
    <div className="max-w-4xl mx-auto px-4 py-12">
      <p className="font-heading text-overline uppercase tracking-[0.2em] text-brand-navy/45 mb-3">Category · {list.total} article{list.total === 1 ? "" : "s"}</p>
      <h1 className="font-sans text-[40px] sm:text-[52px] font-bold text-brand-navy leading-[1.1] tracking-[-0.022em] mb-3">{title}</h1>
      <div className={`h-1 w-20 rounded-full mb-10 ${categoryAccent(category).dot}`} aria-hidden="true" />
      <ul className="space-y-8">
        {list.items.map((a) => (
          <li key={a.id}>
            <Link to={`/${a.category}/${a.slug}`} className="group block">
              <h2 className="text-2xl font-bold text-brand-navy group-hover:underline decoration-brand-navy/40">{a.title.trim()}</h2>
              {a.description ? <p className="text-brand-navy/70 mt-1">{a.description}</p> : null}
              <p className="text-sm text-brand-navy/50 mt-1">
                {formatUtcShortDate(a.publishedAt)}
              </p>
            </Link>
          </li>
        ))}
      </ul>
    </div>
  );
}
